import { useLang } from "@/contexts/LanguageContext";

const PoliticaCookies = () => {
  const { t } = useLang();

  const resetConsent = () => {
    localStorage.removeItem("lc_cookie_consent");
    window.location.reload();
  };

  return (
    <div data-testid="page-politica-cookies">
      <section className="px-6 md:px-12 lg:px-20 pt-16 md:pt-24 pb-12">
        <div className="max-w-4xl mx-auto">
          <div className="text-[11px] uppercase tracking-[0.3em] text-caramel mb-6 font-medium">
            {t.footer.legal}
          </div>
          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl font-light tracking-tighter leading-[0.95] text-ink">
            Política de cookies
          </h1>
        </div>
      </section>

      <section className="px-6 md:px-12 lg:px-20 pb-24 md:pb-32">
        <article className="max-w-4xl mx-auto space-y-12 text-ink-muted font-light text-base md:text-lg leading-relaxed">
          <div>
            <h2 className="font-serif text-3xl md:text-4xl text-ink font-light tracking-tight mb-6">
              ¿Qué son las cookies?
            </h2>
            <p>
              Las cookies son pequeños archivos de texto que se almacenan en tu navegador cuando visitas un
              sitio web. Permiten al sitio recordar información sobre tu visita, como tu idioma preferido o tus
              preferencias de configuración, facilitando la navegación y mejorando la experiencia de uso.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-3xl md:text-4xl text-ink font-light tracking-tight mb-6">
              Cookies utilizadas en este sitio
            </h2>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b-2 border-ink/30">
                    <th className="text-left py-3 pr-4 text-[10px] uppercase tracking-[0.2em] text-caramel font-medium">Cookie</th>
                    <th className="text-left py-3 pr-4 text-[10px] uppercase tracking-[0.2em] text-caramel font-medium">Tipo</th>
                    <th className="text-left py-3 pr-4 text-[10px] uppercase tracking-[0.2em] text-caramel font-medium">Finalidad</th>
                    <th className="text-left py-3 text-[10px] uppercase tracking-[0.2em] text-caramel font-medium">Duración</th>
                  </tr>
                </thead>
                <tbody className="text-ink-muted">
                  <tr className="border-b border-bone">
                    <td className="py-4 pr-4 text-ink font-medium">lc_lang</td>
                    <td className="py-4 pr-4">Técnica · propia</td>
                    <td className="py-4 pr-4">Recordar el idioma elegido por el usuario.</td>
                    <td className="py-4">Persistente</td>
                  </tr>
                  <tr className="border-b border-bone">
                    <td className="py-4 pr-4 text-ink font-medium">lc_cart_v1</td>
                    <td className="py-4 pr-4">Técnica · propia</td>
                    <td className="py-4 pr-4">Conservar los productos añadidos a la solicitud de presupuesto.</td>
                    <td className="py-4">Persistente</td>
                  </tr>
                  <tr className="border-b border-bone">
                    <td className="py-4 pr-4 text-ink font-medium">lc_cookie_consent</td>
                    <td className="py-4 pr-4">Técnica · propia</td>
                    <td className="py-4 pr-4">Registrar la elección del usuario sobre el uso de cookies.</td>
                    <td className="py-4">Persistente</td>
                  </tr>
                  <tr>
                    <td className="py-4 pr-4 text-ink font-medium">PostHog</td>
                    <td className="py-4 pr-4">Analítica · terceros</td>
                    <td className="py-4 pr-4">Análisis agregado del uso del sitio para mejorar la experiencia. Solo se activa si el usuario acepta.</td>
                    <td className="py-4">Hasta 1 año</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div>
            <h2 className="font-serif text-3xl md:text-4xl text-ink font-light tracking-tight mb-6">
              Aceptación y configuración
            </h2>
            <p>
              Al acceder por primera vez al sitio, se muestra un aviso que te permite aceptar o rechazar el uso
              de cookies no esenciales. Las cookies estrictamente técnicas (idioma, carrito y consentimiento) se
              cargan en todo caso por ser imprescindibles para el funcionamiento del sitio.
            </p>
            <p className="mt-4">
              Puedes revocar tu decisión y volver a configurar tus preferencias en cualquier momento utilizando
              el botón inferior, o eliminando las cookies desde la configuración de tu navegador.
            </p>
            <button
              data-testid="cookie-reset-btn"
              onClick={resetConsent}
              className="mt-6 inline-flex items-center gap-3 bg-wine text-bg px-7 py-3 text-xs uppercase tracking-[0.2em] font-medium hover:bg-wine-hover transition-colors"
            >
              Revisar mis preferencias
            </button>
          </div>

          <div>
            <h2 className="font-serif text-3xl md:text-4xl text-ink font-light tracking-tight mb-6">
              Cómo gestionar las cookies en tu navegador
            </h2>
            <p>
              Puedes configurar, restringir o eliminar las cookies a través de las opciones de tu navegador:
            </p>
            <ul className="list-disc pl-6 mt-4 space-y-2">
              <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noreferrer" className="text-wine hover:text-wine-hover">Google Chrome</a></li>
              <li><a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias" target="_blank" rel="noreferrer" className="text-wine hover:text-wine-hover">Mozilla Firefox</a></li>
              <li><a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank" rel="noreferrer" className="text-wine hover:text-wine-hover">Safari</a></li>
              <li><a href="https://support.microsoft.com/es-es/microsoft-edge" target="_blank" rel="noreferrer" className="text-wine hover:text-wine-hover">Microsoft Edge</a></li>
            </ul>
          </div>

          <div className="pt-8 border-t border-bone">
            <p className="text-sm italic">
              Última actualización: enero de 2026. BAIRES FOOD SPAIN S.L., CIF B-01998939.
            </p>
          </div>
        </article>
      </section>
    </div>
  );
};

export default PoliticaCookies;
